export default __webpack_public_path__ + "static/media/046-archery.8a495874.svg";